import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { TableComponent, connect } from "../tableComponent";
import config from '../../config'

class Component extends TableComponent {

  resetOnMount = true

  fetchParams = () => {
    return {
      member_id: this.props.match.params.member_id
    }
  }

  makeColumns = () => {
    return [
      /*{
        Header: "Id",
        accessor: "id",
        minWidth: 50,
        Footer: props => <span>Total</span>
      }, */{
        Header: "Date",
        accessor: "created",
        minWidth: 120,
        Cell: props => 
          <div>{moment(props.value*1000).format("D MMM YYYY, HH:mm:ss")}</div>,
        Footer: props => <span>{this.props.total.count || 0}</span>
      }, {
        Header: "Mid",
        accessor: "support_site",
        minWidth: 100
      }, {
        Header: "Amount",
        accessor: "amount",
        minWidth: 100
      }/*, {
        Header: "Type",
        accessor: "type",
        minWidth: 100
      }*/, {
        Header: "State",
        id: "state",
        accessor: d => d.state == 'settle' ? 'OK' : d.state,
        minWidth: 100
      }, {
        Header: "Crossale #",
        id: "crossale_index",
        accessor: d => parseInt(d.crossale_index)+1,
        minWidth: 100
      }/*, {
        Header: "Success",
        accessor: "success",
        minWidth: 100
      }*/, {
        Header: "Cancel",
        accessor: "id",
        id: "cancel",
        minWidth: 60,
        Cell: props => {
          if (props.original.state == 'settle' || props.original.state == 'auth') {
            return (
              <button 
                type="button" 
                class="btn btn-sm btn-block btn-aff-toggle warning"
                onClick={e => {this.handleToggleData("canceled",props,"state",true)}}>Refund                
              </button>            
            )
          }/* else if (props.original.state == "canceled") {
            return <div>canceled</div>
          }*/ else {
            return <div>{props.original.state == 'canceled' ? 'Refunded' : props.original.state}</div>
          }
        }          
      }
    ]
  }

  apiPath = "hookupbay/transactions"
  editApiPath = "hookupbay/update_transaction"

  tableParams = {
    manual: true,
    sorted: [{
      id: "id",
      desc: true
    }],
    showAll: false
  }

  // cancelTransaction = (props) => {
  //   props.original.state_original = props.original.state
  //   props.original.state = "canceled"
  //   let items = this.props.items;
  //   items[props.index].state = "canceled";    
  //   this.props.changeItems(items);

  //   if (!key) {
  //     key = props.column.id
  //   }
  //   newValue = Number(newValue)
  //   props.value = newValue;
  //   props.original[key+"_original"] = props.original[key];
  //   props.original[key] = newValue;

    
  //   this.handleSubmitData(props,key)    
  // }

  render() {
    return (
      <div>
        <div class="row">
          <div class="col-sm-12">
            <div class="box mt-2">{this.reactTable()}</div>
          </div>
        </div>
      </div> 
    );
  }
}

export default connect(Component,"hookupbay_transactions")

